export default __webpack_public_path__ + "static/media/s.c882d4d1.png";